/**
 * Canonical analytics event names for the authentication (login / register) domain.
 *
 * These events fire during sign-in and sign-up, some of which occur before a
 * workspace exists. They are consumed through `useAnalyticsAuth().trackAuthEvent`,
 * which emits without a workspace guard so pre-workspace steps are not dropped.
 *
 * Naming: `front.<login|register>.<entity>.<action>`; leaf tokens preserve the
 * existing product event names (e.g. `clicked_signUp`, `email_step`).
 */
export const AUTH_EVENTS = {
  CLICKED_SIGN_UP: 'front.login.button.clicked_signUp',
  LOGIN_SUCCESS: 'front.login.success',
  GOOGLE: 'front.register.button.google',
  EMAIL_STEP: 'front.register.button.email_step',
  PASSWORD_STEP: 'front.register.button.password_step',
  PERSONAL_INFO_STEP: 'front.register.button.personal_info_step',
  OTP_STEP: 'front.register.button.otp_step',
  INDUSTRY_STEP: 'front.register.button.industry_step',
  WORKSPACE_STEP: 'front.register.button.workspace_step',
  NEW_TEAM_USER_LOGIN: 'front.register.newTeamUser.login_btn.click',
  ERROR_ACCOUNT_ALREADY_EXIST: 'front.register.page.error_account_already_exist',
} as const;

/**
 * Possible outcomes of the OTP verification step, carried on
 * `front.register.button.otp_step` as the `otp_status` property: successful
 * verification, a validation/resend error, a code resend, skipping the step,
 * or going back to modify the phone number.
 */
export const OTP_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  RESEND: 'resend',
  SKIP: 'skip',
  BACK: 'back',
} as const;

/**
 * Union of every valid `otp_status` property value.
 */
export type tOtpStatus = (typeof OTP_STATUS)[keyof typeof OTP_STATUS];
